import { z } from "zod";

export const GAS_LIMIT_VALUES = ["slow", "average", "fast"] as const;
export type GasLimit = (typeof GAS_LIMIT_VALUES)[number];
export const GasLimitSchema = z.enum(GAS_LIMIT_VALUES);

export const GAS_LIMIT_LABELS: Record<GasLimit, string> = {
  slow: "Slow",
  average: "Average",
  fast: "Fast",
};
